export default {"src":"/_next/static/media/pharmacy-products-ordered.0cb3e378.svg","height":234,"width":244,"blurWidth":0,"blurHeight":0};